import { type FC } from 'react'

import { useProductPageContext } from '../productPageContext'

import { ProductBreadcrumbsItems } from './ProductBreadcrumbsItems'

export const ProductBreadcrumbs: FC = () => {
  const { breadcrumbs } = useProductPageContext()

  if (!breadcrumbs) {
    return null
  }

  return (
    <div className="container py-3">
      <div className="flex h-[1lh] items-center gap-2 text-dark-primary-strong desktop:flex-wrap desktop:overflow-hidden desktop:text-xs">
        <ProductBreadcrumbsItems />
      </div>
    </div>
  )
}
